import React from 'react'
// import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import favicon16 from "../assets/images/favicon16.png";
import favicon32 from "../assets/images/favicon32.png";
import favicon64 from "../assets/images/favicon64.png";
import product_logo from '../assets/images/rekon_logo.png'

const mailToLink = 'mailto:sales@rekon.com?Subject=Rekon%20Website%3A%20Requesting%20Software%20Demonstration'

const RekonPage = () => (
  <div>
      <Helmet
        title="Rekon"
        meta={[
          { name: 'description', content: 'Rekon: Servicers\' Number One Choice for lean release and assignement software.' }
        ]}
       link={[
        { rel: "icon", type: "image/png", sizes: "16x16", href: `${favicon16}` },
        { rel: "icon", type: "image/png", sizes: "32x32", href: `${favicon32}` },
        { rel: "shortcut icon", type: "image/png", href: `${favicon64}` },
       ]}
      />
    <div className="hero hero-product hero-rekon is-medium">
      <div className="hero-body">
        <div className="container has-text-centered">
          <img src={product_logo} alt="Rekon logo" className="product-logo"/>
          <h1 className="title">The Mortgage Industry’s Most-Trusted Solution</h1>
          <p>Rekon's flagship software solution prepares lien releases and assignments and automatically applies the unique requirements of more than 3,600 recording offices, significantly reducing recording errors and penalties.</p>
        </div>
      </div>
    </div>
    <section className="section product-features">
      <div className="container">
        <h2 className="title has-text-centered">With Rekon, you are able to:</h2>
        <div className="features-list-container columns is-mobile is-multiline">
          <div className="column is-full-mobile is-4-desktop">
            <ul>
            <li>Produce documents <br/><strong>quickly</strong> and <strong>accurately</strong></li>
            <li><strong>Comply</strong> with recording <br/> requirements</li>
            <li><strong>Automatically calculate</strong> <br/> recording fees</li>
            </ul>
          </div>
          <div className="column is-full-mobile is-4-desktop">
            <ul>
              <li><strong>Fully control</strong> workflow processes</li>
              <li>Increase <strong>compliance rates</strong></li>
              <li><strong>Evenly distribute</strong> signing queues</li>
            </ul>
          </div>
          <div className="column is-full-mobile is-4-desktop">
            <ul>
              <li><strong>Electronically</strong> record documents</li>
              <li>Monitor <strong>productivity</strong> and <strong>performance</strong></li>
              <li><strong>Configure</strong> and <strong>schedule</strong> reports</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section className="section product-promo">
      <div className="has-text-centered">
        <span className="title fg-grey block">
          You need to get it right.
        </span>
        <span className="title fg-success block">
          Rekon makes it happen.
        </span>
      </div>
    </section>
    <section className="core-features">
      <div className="section container has-text-centered">
        <h2 className="title">Why Rekon is the Complete Package</h2>
        <p>Rekon automates the lien release and assignment process while providing fully integrated workflows, powerful analytics and eRecording capabilities.</p>
        <div className="columns core-features-columns">
          <div className="column">
            <h3 className="title">
              <i className="has-icon icon-folder"></i>
              <span className="is-centered">Complete <br/>Coverage</span>
            </h3>
            <p>
              Rekon stores and updates all recording requirements and stays in constant communication with local recording offices so that any changes are quickly incorporated into the software.
            
            </p>
          </div>
          <div className="column">
            <h3 className="title">
              <i className="has-icon icon-deficiencies"></i>
              <span className="is-centered">Maximum <br/>Efficiency</span>
            </h3>
            <p>
              Rekon automates tasks, including data entry, calculating recording fees and generating checks for payment. Workflows are automatically assigned and time spent on every work queue is tracked, enabling servicers to measure and improve staff productivity. 
            
            </p>
          </div>
          <div className="column">
            <h3 className="title">
              <i className="has-icon icon-streamline"></i>
              <span className="is-centered">Recording <br/>Precision</span>
            </h3>
            <p>
              The vast number of recording requirements makes it nearly impossible to manually record lien releases and assignments without error, which can result in costly delays. Rekon’s elegant technology solution streamlines the entire process so servicers are always in control of their documents. 
            
            </p>
          </div>
        </div>
      </div>
    </section>
    <section className="hero is-default container-testimonials">
      <div className="hero-body has-text-centered">
        <blockquote>
          <p>The control you have over the queues and how they operate really allows you to customize the system to your needs, whether process 10,000 documents a month or 100,000 a month. I can honestly say I’m glad we made the switch to Rekon WorkFlow.</p>
          <small>- Aaron Marcheski, AVP Bancorp Collateral Servicing Manager, Fifth Third Bank</small>
        </blockquote>
      </div>
    </section>
    <section className="section container-cta has-text-centered">
      <h2 className="title fg-success">Rekon gets it right.</h2>
      <p>There’s a reason why the majority of the top 10 mortgage servicers trust Rekon to process their lien releases and assignments with effortless precision.</p>
      <button onClick={() => window.location.href = mailToLink} className="button is-primary is-large" aria-label="Request a Demo of our Software">Schedule a demo today</button>
    </section>
  </div>
)

export default RekonPage



// WEBPACK FOOTER //
// ./src/pages/rekon.js